import { render } from "./Recension.vue?vue&type=template&id=aeb81e36&scoped=true"
import script from "./Recension.vue?vue&type=script&lang=js"
export * from "./Recension.vue?vue&type=script&lang=js"

import "./Recension.vue?vue&type=style&index=0&id=aeb81e36&lang=scss&scoped=true"

import exportComponent from "/home/ajdin/forspace-web/forspace/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-aeb81e36"]])

export default __exports__